// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

// 全局变量
import global  from './components/Global.vue'
Vue.prototype.global = global.global;

import axios from '@/plugins/axios';
import pull from '@/api/pull';
import 'babel-polyfill'

//使用注册
Vue.use(axios);
Vue.use(pull);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js